import { Colors } from 'common/models/theme';

const darkColors: Colors = {
  bgColor: '#141826',
  transparent: 'transparent',
  primaryTextColor: '#ffffff',
  secondaryTextColor: '#787E91',
  black: '#000000',
  white: '#ffffff',
  // headingColor: '#0676FF',
  headingColor: '#787E91',
  secondaryHeaderColor: '#ffffff',
  subHeadingColor: '#ffffff',
  textColor: '#43414e',
  subTextColor: '#5381B9',
  headerLinkColor: '#ffffff',
  linkColor: '#016DF2',
  labelColor: '#767676',
  inactiveField: '#f2f2f2',
  inactiveButton: '#b7dbdd',
  inactiveIcon: '#EBEBEB',
  // primary: '#2aa275',
  primary: '#1A7EFB',
  primaryDisabled: '#CCF2E5',
  primaryHover: '#2aa275',
  secondary: '#edcd37',
  secondaryHover: '#edcd37',
  yellow: '#fdb32a',
  yellowHover: '#F29E02',
  // General
  primaryButtonBgColor: '#00BD7B',
  primaryButtonColor: '#ffffff',
  footerBgColor: '#122F3D',
  hrBgColor: '#243757',
  borderColor: '#1b1e25', //14
  primaryBoxShadow: '0px 8px 20px -6px rgba(42, 162, 117, 0.57)',
  secondaryBoxShadow: '0px 8px 20px -6px rgba(237, 205, 55, 0.5)',
  sidebarBackgroundColor: '#0C0F18',
  contentBgColor: '#1f2c53',
  // contentBgColor: '#131823',
  contentInnerBgColor: '#071426',
  contentInnerInnerBgColor: '#122139',
  // General Table
  tableBorderBottom: '1px solid #252A34',
  // General Input
  inputBorder: '1px solid #252A34',
  inputBorderColor: '#252A34',
  inputLabelColor: '#5280B7',
  inputBgColor: '#0C0F18',
  inputPlaceholderColor: '#5280B7',
  // Modal
  modalBgColor: '#152037',
};

export default darkColors;
